// extracted by mini-css-extract-plugin
module.exports = {"graphic":"Graphic_graphic__PZUua"};